var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiRound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 386,
    viewBox: "0 0 386 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192.651C0 298.966 86.1852 385.151 192.5 385.151C298.815 385.151 385 298.966 385 192.651C385 86.3366 298.815 0.151367 192.5 0.151367C86.1852 0.151367 0 86.3366 0 192.651Z",
    fill: "url(#paint0_radial_1596_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.368 88.8486C178.412 88.8486 179.257 89.7043 179.257 90.7569C179.257 95.9492 179.257 110.303 179.257 115.495C179.257 116.55 178.412 117.404 177.368 117.404C171.406 117.404 153.028 117.404 147.065 117.404C146.022 117.404 145.177 116.55 145.177 115.495C145.177 110.303 145.177 95.9492 145.177 90.7569C145.177 89.7043 146.022 88.8486 147.065 88.8486C153.028 88.8486 171.406 88.8486 177.368 88.8486ZM236.727 88.8486C237.773 88.8486 238.618 89.7043 238.618 90.7569C238.618 95.9492 238.618 110.303 238.618 115.495C238.618 116.55 237.773 117.404 236.727 117.404C230.77 117.404 212.389 117.404 206.427 117.404C205.385 117.404 204.54 116.55 204.54 115.495C204.54 110.303 204.54 95.9492 204.54 90.7569C204.54 89.7043 205.385 88.8486 206.427 88.8486C212.389 88.8486 230.77 88.8486 236.727 88.8486ZM145.177 166.15H123.448V187.433C123.448 187.938 123.25 188.425 122.895 188.783C122.541 189.14 122.061 189.34 121.56 189.34C115.539 189.34 96.8491 189.34 90.8288 189.34C90.3279 189.34 89.8476 189.14 89.4937 188.783C89.1397 188.425 88.9404 187.938 88.9404 187.433V166.581C88.9404 157.34 92.5757 148.477 99.0479 141.939C105.519 135.404 114.296 131.733 123.448 131.733H261.744V113.986C261.744 112.933 262.589 112.08 263.631 112.08C269.654 112.08 288.344 112.08 294.366 112.08C295.409 112.08 296.254 112.933 296.254 113.986C296.254 117.12 296.254 123.768 296.254 131.302C296.254 140.546 292.618 149.409 286.147 155.944C279.674 162.479 270.899 166.15 261.747 166.15H238.618V284.257C238.618 285.057 238.128 285.768 237.386 286.044C233.206 287.605 219.397 292.754 211.07 295.857C209.584 296.415 207.916 296.198 206.617 295.283C205.316 294.364 204.54 292.864 204.54 291.259V166.15H179.257V284.257C179.257 285.057 178.764 285.768 178.023 286.044C173.844 287.605 160.034 292.754 151.71 295.857C150.221 296.415 148.557 296.198 147.255 295.283C145.952 294.364 145.177 292.864 145.177 291.259V166.15Z",
    fill: "#F2B65F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.597 28.5703C283.073 28.5703 356.532 102.025 356.532 192.505C356.532 282.983 283.073 356.44 192.597 356.44C102.118 356.44 28.6607 282.983 28.6607 192.505C28.6607 102.025 102.118 28.5703 192.597 28.5703ZM192.597 0C298.844 0 385.102 86.2595 385.102 192.505C385.102 298.751 298.844 385.01 192.597 385.01C86.3505 385.01 0.0917969 298.751 0.0917969 192.505C0.0917969 86.2595 86.3505 0 192.597 0Z",
    fill: "#F2B65F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1596_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.5 192.651) scale(209.183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#392761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#392760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#382760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#38265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#37265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#37265E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#36265D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#36265D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#35265C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#35265C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#34265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#34255A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#33255A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#332559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#322558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#322558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#312557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#302556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#302455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#2F2455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#2F2454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#2E2453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#2E2453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#2D2452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#2D2451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#2C2451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#2C2350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#2B234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#2A234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#2A234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#2A234D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#29234D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#29234C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#28234C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#28224B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#27224B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#27224A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#27224A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#262249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#262248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#252248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#252247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#242247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#242146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#232145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#222144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#212143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#212142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#202142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#202041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#202041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#1F2041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#1F2040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#1E203F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E203F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiRound);
export default __webpack_public_path__ + "static/media/piRound.8b7ad303e7d2fb81e0637f9ea9c54dba.svg";
export { ForwardRef as ReactComponent };